// A single chat message inside a Conversation. The backend sends
// { role, content, source?, elapsed? } (assistant frames add source/elapsed/metadata).
export class Message {
  constructor({
    role = '',
    content = '',
    source = null,
    elapsed = null,
    metadata = {},
    created_at = '',
  } = {}) {
    this.role = role;
    this.content = content;
    this.source = source;
    this.elapsed = elapsed;
    this.metadata = metadata || {};
    this.created_at = created_at;
  }

  static validate(messageData) {
    if (!messageData.role) {
      throw new Error('Role is required');
    }
    if (messageData.content === undefined || messageData.content === null || messageData.content === '') {
      throw new Error('Content is required');
    }
  }
}

export default class Conversation {
  constructor({
    id = null,
    student_id = null,
    teacher_id = null,
    subtask_id = null,
    messages = [],
    created_at = '',
    updated_at = '',
  } = {}) {
    this.id = id;
    this.student_id = student_id;
    this.teacher_id = teacher_id;
    this.subtask_id = subtask_id;
    // Parse raw message dicts into Message instances (idempotent for already-parsed ones).
    this.messages = (messages || []).map((m) => (m instanceof Message ? m : new Message(m)));
    this.created_at = created_at;
    this.updated_at = updated_at;
  }

  // Basic validation for conversation data. subtask_id is intentionally optional
  // (a "general" chat carries no task), mirroring the backend contract.
  static validate(conversationData) {
    if (!conversationData.student_id) {
      throw new Error('Student ID is required');
    }
    if (conversationData.messages && !Array.isArray(conversationData.messages)) {
      throw new Error('Messages must be an array');
    }
  }

  // A short label derived from the first user message (for the conversation list).
  get title() {
    const firstUser = this.messages.find((m) => m.role === 'user' && m.content);
    const text = (firstUser && firstUser.content) || '';
    const trimmed = text.trim();
    if (!trimmed) {
      return 'Untitled chat';
    }
    return trimmed.length > 40 ? `${trimmed.slice(0, 40)}…` : trimmed;
  }

  // Format date to DD.MM.YYYY (mirrors the other models).
  static formatDate(datetime) {
    if (!datetime) {
      return '';
    }
    const date = new Date(datetime);
    return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
  }
}
